import { FormikHelpers } from "formik";
import PhoneCenterForm from "./PhoneCenterForm";
import { useGetPhoneCenter } from "./api/getPhoneCenter";
import { useEditPhoneCenter } from "./api/editPhoneCenter";
import { IEditPhoneCenterForm } from "./phoneCenter";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditPhoneCenter = ({handleCloseModal, PhoneCenterId}: EditPhoneCenterProps)  => {
  const getPhoneCenterQuery = useGetPhoneCenter({PhoneCenterId: PhoneCenterId})
  const editPhoneCenterMutation = useEditPhoneCenter({data: {}, PhoneCenterId});

  const initialValues: IEditPhoneCenterForm = {
    description: getPhoneCenterQuery.data?.description ? getPhoneCenterQuery.data.description : "",
    unitID: getPhoneCenterQuery.data?.unitID ? getPhoneCenterQuery.data.unitID.toString() : "",
    phoneCentersSysModelId: getPhoneCenterQuery.data?.phoneCentersSysModelId ? getPhoneCenterQuery.data.phoneCentersSysModelId.toString() : "",
    phoneCentersMaintenanceId: getPhoneCenterQuery.data?.phoneCentersMaintenanceId ? getPhoneCenterQuery.data.phoneCentersMaintenanceId.toString() : "",
    incomingLines: getPhoneCenterQuery.data?.incomingLines ? getPhoneCenterQuery.data.incomingLines : "",
    outgoingLines: getPhoneCenterQuery.data?.outgoingLines ? getPhoneCenterQuery.data.outgoingLines : "",
    channelNumber: getPhoneCenterQuery.data?.channelNumber ? getPhoneCenterQuery.data.channelNumber : "",
    workstaions: getPhoneCenterQuery.data?.workstaions ? getPhoneCenterQuery.data.workstaions : "",
    elevatorNumber: getPhoneCenterQuery.data?.elevatorNumber ? getPhoneCenterQuery.data.elevatorNumber : "",
    fctNumber: getPhoneCenterQuery.data?.fctNumber ? getPhoneCenterQuery.data.fctNumber : "",
    errorCode: getPhoneCenterQuery.data?.errorCode ? getPhoneCenterQuery.data.errorCode : "",
    internalsNumber: getPhoneCenterQuery.data?.internalsNumber ? getPhoneCenterQuery.data.internalsNumber : "",
    comments: getPhoneCenterQuery.data?.comments ? getPhoneCenterQuery.data.comments : "",
    fileLink: getPhoneCenterQuery.data?.fileLink ? getPhoneCenterQuery.data.fileLink : "",
    isPSTN: getPhoneCenterQuery.data?.isPSTN ? getPhoneCenterQuery.data.isPSTN : false ,
    isISDN: getPhoneCenterQuery.data?.isISDN ? getPhoneCenterQuery.data.isISDN : false ,
    is30PRI: getPhoneCenterQuery.data?.is30PRI ? getPhoneCenterQuery.data.is30PRI : false,
    isLine: getPhoneCenterQuery.data?.isLine ? getPhoneCenterQuery.data.isLine : false,
    providers: getPhoneCenterQuery.data?.providers ?  getPhoneCenterQuery.data.providers: [],
  };


  const handleSubmit = async (values: IEditPhoneCenterForm, { setSubmitting }: FormikHelpers<IEditPhoneCenterForm>): Promise<void> => {
    try {
      await editPhoneCenterMutation.mutateAsync({
        data: values,
        PhoneCenterId: PhoneCenterId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getPhoneCenterQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPhoneCenterQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τηλεφωνικού Κέντρου.</div>
    )
  }

  return (
    <>
      {!getPhoneCenterQuery.isLoading && getPhoneCenterQuery.data &&
        <PhoneCenterForm initialValues={initialValues} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditPhoneCenterProps {
  PhoneCenterId: number;
  handleCloseModal: () => void;
}

export default EditPhoneCenter;